export default __webpack_public_path__ + "static/media/instagram.1ef2ee37.svg";